module.exports = function (e) {
  var n = {};

  function t(r) {
    if (n[r]) return n[r].exports;
    var o = n[r] = {
      i: r,
      l: !1,
      exports: {}
    };
    return e[r].call(o.exports, o, o.exports, t), o.l = !0, o.exports;
  }

  return t.m = e, t.c = n, t.d = function (e, n, r) {
    t.o(e, n) || Object.defineProperty(e, n, {
      enumerable: !0,
      get: r
    });
  }, t.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, t.t = function (e, n) {
    if (1 & n && (e = t(e)), 8 & n) return e;
    if (4 & n && "object" == typeof e && e && e.__esModule) return e;
    var r = Object.create(null);
    if (t.r(r), Object.defineProperty(r, "default", {
      enumerable: !0,
      value: e
    }), 2 & n && "string" != typeof e) for (var o in e) {
      t.d(r, o, function (n) {
        return e[n];
      }.bind(null, o));
    }
    return r;
  }, t.n = function (e) {
    var n = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return t.d(n, "a", n), n;
  }, t.o = function (e, n) {
    return Object.prototype.hasOwnProperty.call(e, n);
  }, t.p = "", t(t.s = 5);
}([function (e, n) {
  e.exports = require("react");
}, function (e, n, t) {
  e.exports = t(3)();
}, function (e, n) {
  e.exports = require("styled-components");
}, function (e, n, t) {
  "use strict";

  var r = t(4);

  function o() {}

  function i() {}

  i.resetWarningCache = o, e.exports = function () {
    function e(e, n, t, o, i, a) {
      if (a !== r) {
        var c = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        throw c.name = "Invariant Violation", c;
      }
    }

    function n() {
      return e;
    }

    e.isRequired = e;
    var t = {
      array: e,
      bool: e,
      func: e,
      number: e,
      object: e,
      string: e,
      symbol: e,
      any: e,
      arrayOf: n,
      element: e,
      elementType: e,
      instanceOf: n,
      node: e,
      objectOf: n,
      oneOf: n,
      oneOfType: n,
      shape: n,
      exact: n,
      checkPropTypes: i,
      resetWarningCache: o
    };
    return t.PropTypes = t, t;
  };
}, function (e, n, t) {
  "use strict";

  e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
}, function (e, n, t) {
  "use strict";

  t.r(n);
  var r = t(0),
      o = t.n(r),
      i = t(1),
      a = t.n(i),
      c = Object(r.createContext)({}),
      u = c.Provider,
      l = c;

  function s(e) {
    for (var n = 1; n < arguments.length; n++) {
      if (n % 2) {
        var t = null != arguments[n] ? arguments[n] : {},
            r = Object.keys(t);
        "function" == typeof Object.getOwnPropertySymbols && (r = r.concat(Object.getOwnPropertySymbols(t).filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        }))), r.forEach(function (n) {
          d(e, n, t[n]);
        });
      } else Object.defineProperties(e, Object.getOwnPropertyDescriptors(arguments[n]));
    }

    return e;
  }

  function d(e, n, t) {
    return n in e ? Object.defineProperty(e, n, {
      value: t,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[n] = t, e;
  }

  function f(e, n) {
    return function (e) {
      if (Array.isArray(e)) return e;
    }(e) || function (e, n) {
      var t = [],
          r = !0,
          o = !1,
          i = void 0;

      try {
        for (var a, c = e[Symbol.iterator](); !(r = (a = c.next()).done) && (t.push(a.value), !n || t.length !== n); r = !0) {
          ;
        }
      } catch (e) {
        o = !0, i = e;
      } finally {
        try {
          r || null == c.return || c.return();
        } finally {
          if (o) throw i;
        }
      }

      return t;
    }(e, n) || function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }();
  }

  var p = {
    translateDrag: 0,
    translateDuration: .5,
    x0: null
  },
      v = function v(e, n, t) {
    var o = f(Object(r.useState)(p), 2),
        i = o[0],
        a = o[1];
    Object(r.useEffect)(function () {
      return document.addEventListener("mouseup", c, !1), document.addEventListener("touchend", c, !1), function () {
        document.removeEventListener("mouseup", c), document.removeEventListener("touchend", c);
      };
    }, []);

    var c = function c() {
      a(p);
    },
        u = function u(r) {
      if (i.x0) {
        var o = v(r).clientX,
            c = o - i.x0,
            u = Math.sign(c),
            l = +(u * c / n).toFixed(2);
        if (a({
          x0: null,
          translateDrag: 0,
          translateDuration: 1 - l
        }), l > .2) t(e - u);else if (0 === l) {
          var s = r.target.getBoundingClientRect(),
              d = s.x,
              f = s.width,
              y = o - d;
          u = Math.sign(f / 2 - y), t(e - u);
        }
      } else a(p);
    },
        l = function l(e) {
      var n = v(e).clientX;
      a(function (e) {
        return s({}, e, {
          x0: n,
          translateDuration: 0
        });
      });
    },
        d = function d(e) {
      if (i.x0) {
        var n = v(e).clientX;
        a(function (e) {
          return s({}, e, {
            translateDrag: Math.round(n - e.x0)
          });
        });
      }
    },
        v = function v(e) {
      return e.changedTouches ? e.changedTouches[0] : e;
    };

    return {
      listeners: {
        onTouchStart: l,
        onTouchMove: d,
        onTouchEnd: u,
        onMouseDown: l,
        onMouseMove: d,
        onMouseUp: u
      },
      translateState: i
    };
  },
      y = t(2),
      g = t.n(y);

  function m() {
    var e = q(["\n  background-image: url(", ");\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n  display: inline-block;\n  width: ", ";\n  min-width: ", ";\n  height: 100%;\n  margin: 0px;\n  cursor: pointer;\n  border: ", ";\n  transition: border 0.5s;\n"]);
    return m = function m() {
      return e;
    }, e;
  }

  function b() {
    var e = q(["\n  position: relative;\n  bottom: 0;\n  width: 100%;\n  height: 10%;\n  margin: auto;\n  display: ", ";\n  align-items: center;\n  z-index: 10;\n  transform: translate(0, -0%);\n  overflow: hidden;\n  overflow-x: scroll;\n"]);
    return b = function b() {
      return e;
    }, e;
  }

  function h() {
    var e = q(["\n  background: ", ";\n  display: inline-block;\n  width: 10px;\n  height: 10px;\n  margin: 0 10px;\n  cursor: pointer;\n  border-radius: 50%;\n"]);
    return h = function h() {
      return e;
    }, e;
  }

  function w() {
    var e = q(["\n  flex: 1;\n  bottom: 0;\n  width: 100%;\n  height: 10%;\n  margin: auto;\n  display: ", ";\n  justify-content: center;\n  align-items: center;\n  transform: translate(0, -0%);\n"]);
    return w = function w() {
      return e;
    }, e;
  }

  function x() {
    var e = q(["\n  border: solid ", ";\n  border-width: 0 4px 4px 0;\n  display: ", ";\n  margin: 20px;\n  padding: 7px;\n  transform: rotate(", ");\n"]);
    return x = function x() {
      return e;
    }, e;
  }

  function O() {
    var e = q(["\n  width: 40%;\n  height: 100%;\n  cursor: pointer;\n  align-items: center;\n  display: flex;\n  opacity: ", ";\n  justify-content: ", ";\n  img {\n    width: 40px;\n    transform: translate(0, -50%);\n    transition: opacity 0.4s;\n  }\n  transition: opacity 0.3s ease;\n  &:hover {\n    opacity: 1;\n  }\n"]);
    return O = function O() {
      return e;
    }, e;
  }

  function S() {
    var e = q(["\n  position: relative;\n  z-index: 5;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  transform: translate(0, -100%);\n  user-select: none;\n"]);
    return S = function S() {
      return e;
    }, e;
  }

  function j() {
    var e = q(["\n  width: 100%;\n  white-space: normal;\n"]);
    return j = function j() {
      return e;
    }, e;
  }

  function E() {
    var e = q(["\n  margin: 10px;\n  margin-bottom: 5px;\n  font-weight: 600;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"]);
    return E = function E() {
      return e;
    }, e;
  }

  function T() {
    var e = q(["\n  background: #fffa;\n  color: #333;\n  text-align: center;\n  width: 100.5%;\n  position: absolute;\n  padding: 15px 20px;\n  bottom: 0;\n  left: 50%;\n  transform: translate(-50%, 0);\n"]);
    return T = function T() {
      return e;
    }, e;
  }

  function C() {
    var e = q(["\n  display: inline-block;\n  width: 100%;\n  height: 100%;\n  position: relative;\n  background-image: url(", ");\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: ", ";\n"]);
    return C = function C() {
      return e;
    }, e;
  }

  function P() {
    var e = q(["\n  width: 100%;\n  height: 100%;\n  z-index: 1;\n  transform: translateX(\n    ", "\n  );\n  transition: ", ";\n"]);
    return P = function P() {
      return e;
    }, e;
  }

  function R() {
    var e = q(["\n  overflow: hidden;\n  white-space: nowrap;\n  flex: 9;\n  width: 100%;\n"]);
    return R = function R() {
      return e;
    }, e;
  }

  function k() {
    var e = q(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n"]);
    return k = function k() {
      return e;
    }, e;
  }

  function q(e, n) {
    return n || (n = e.slice(0)), Object.freeze(Object.defineProperties(e, {
      raw: {
        value: Object.freeze(n)
      }
    }));
  }

  var A = g.a.div(k()),
      D = g.a.div(R()),
      _ = g.a.div(P(), function (e) {
    var n = e.sliderWidth,
        t = e.index,
        r = e.translateDrag;
    return "".concat(-t * n + (void 0 === r ? 0 : r), "px");
  }, function (e) {
    var n = e.transition,
        t = e.translateDuration;
    return n ? "transform cubic-bezier(0,.59,.46,1) ".concat(.7 * (void 0 === t ? .5 : t), "s") : "none";
  }),
      I = g.a.div(C(), function (e) {
    return e.image;
  }, function (e) {
    return e.cover ? "cover" : "contain";
  }),
      M = g.a.div(T()),
      z = g.a.div(E()),
      L = g.a.p(j()),
      H = g.a.div(S()),
      W = g.a.div(O(), function (e) {
    return e.hover ? "0" : "1";
  }, function (e) {
    return "left" === e.direction ? "flex-start" : "flex-end";
  }),
      X = g.a.div(x(), function (e) {
    return e.primaryColor;
  }, function (e) {
    return e.displayArrows ? "flex" : "none";
  }, function (e) {
    return "left" === e.direction ? "135deg" : "-45deg";
  }),
      B = g.a.div(w(), function (e) {
    return e.displayDot ? "flex" : "none";
  }),
      N = g.a.div(h(), function (e) {
    var n = e.active,
        t = e.colors;
    return n ? t.b : t.a;
  }),
      U = g.a.div(b(), function (e) {
    return e.displayPreview ? "flex" : "none";
  }),
      F = g.a.div(m(), function (e) {
    return e.image;
  }, function (e) {
    var n = e.length;
    return "".concat(100 / n, "%");
  }, function () {
    return "".concat(10, "%");
  }, function (e) {
    var n = e.active,
        t = e.color;
    return n ? "solid 3px ".concat(t) : "solid 0px ".concat(t);
  });

  function V(e) {
    var n = e.curr,
        t = e.taglineStyle,
        r = e.titleStyle,
        i = e.captionStyle;
    return n.title || n.caption ? o.a.createElement(M, {
      style: t
    }, o.a.createElement(z, {
      style: r
    }, n.title), o.a.createElement(L, {
      style: i
    }, n.caption)) : null;
  }

  V.propTypes = {
    curr: a.a.objectOf(a.a.strings).isRequired,
    taglineStyle: a.a.object.isRequired,
    titleStyle: a.a.object.isRequired,
    captionStyle: a.a.object.isRequired
  };
  var Y = V;

  function G() {
    return (G = Object.assign || function (e) {
      for (var n = 1; n < arguments.length; n++) {
        var t = arguments[n];

        for (var r in t) {
          Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
        }
      }

      return e;
    }).apply(this, arguments);
  }

  var J = function J() {
    var e = Object(r.useContext)(l),
        n = e.index,
        t = e.images,
        i = e.cover,
        a = void 0 === i || i,
        c = e.transition,
        u = void 0 === c || c,
        s = e.swipe,
        d = void 0 !== s && s,
        f = e.goToSlide,
        p = e.slideStyle,
        y = e.taglineStyle,
        g = e.titleStyle,
        m = e.captionStyle,
        b = Object(r.useRef)(),
        h = b.current && b.current.getBoundingClientRect().width,
        w = v(n, h, f),
        x = w.listeners,
        O = w.translateState,
        S = t.map(function (e, n) {
      return o.a.createElement(I, {
        key: n,
        style: p,
        cover: a,
        image: e.image
      }, o.a.createElement(Y, {
        curr: e,
        taglineStyle: y,
        titleStyle: g,
        captionStyle: m
      }));
    });
    return o.a.createElement(_, G({}, x, {
      sliderWidth: h,
      transition: d || u,
      index: n
    }, O, {
      ref: b
    }), S);
  },
      K = function K(e) {
    var n = e.callToAction,
        t = e.direction,
        r = e.arrowStyle,
        i = e.displayArrows,
        a = e.arrowOnHover,
        c = e.arrowImg,
        u = e.primaryColor;
    return o.a.createElement(W, {
      direction: t,
      hover: a,
      onClick: n
    }, c ? o.a.createElement("img", {
      src: c,
      style: r,
      alt: ""
    }) : o.a.createElement(X, {
      displayArrows: i,
      direction: t,
      style: r,
      primaryColor: u
    }));
  };

  K.propTypes = {
    callToAction: a.a.func.isRequired,
    direction: a.a.string.isRequired,
    arrowStyle: a.a.object.isRequired,
    displayArrows: a.a.bool.isRequired,
    arrowOnHover: a.a.bool.isRequired,
    arrowImg: a.a.string.isRequired,
    primaryColor: a.a.string.isRequired
  };

  var Q = K,
      Z = function Z() {
    var e = Object(r.useContext)(l),
        n = e.arrowStyle,
        t = e.displayArrows,
        i = void 0 === t || t,
        a = e.arrowOnHover,
        c = void 0 !== a && a,
        u = e.primaryColor,
        s = void 0 === u ? "#CCC" : u,
        d = e.arrowLeftImg,
        f = e.arrowRightImg,
        p = e.goToPreviousSlide,
        v = e.goToNextSlide,
        y = e.swipe,
        g = void 0 !== y && y,
        m = e.images,
        b = e.index,
        h = e.loop,
        w = void 0 === h || h;
    return !g && o.a.createElement(H, null, w || b > 0 ? o.a.createElement(Q, {
      arrowStyle: n,
      displayArrows: i,
      arrowImg: d,
      arrowOnHover: c,
      callToAction: p,
      primaryColor: s,
      direction: "left"
    }) : o.a.createElement("div", null), w || b < m.length - 1 ? o.a.createElement(Q, {
      arrowStyle: n,
      displayArrows: i,
      arrowImg: f,
      arrowOnHover: c,
      callToAction: v,
      primaryColor: s,
      direction: "right"
    }) : o.a.createElement("div", null));
  },
      $ = function $() {
    var e = Object(r.useContext)(l),
        n = e.index,
        t = e.images,
        i = e.goToSlide,
        a = e.dotStyle,
        c = e.dotActiveStyle,
        u = e.displayDot,
        s = void 0 === u || u,
        d = e.primaryColor,
        f = void 0 === d ? "#CCC" : d,
        p = e.secondaryColor,
        v = void 0 === p ? "#333" : p,
        y = e.dotsContainerStyle,
        g = function g(e) {
      e === n || i(e);
    },
        m = Object.assign({}, c, a);

    return o.a.createElement(B, {
      displayDot: s,
      style: y
    }, t.map(function (e, t) {
      return o.a.createElement(N, {
        key: t,
        style: t === n ? m : a,
        active: t === n,
        colors: {
          a: f,
          b: v
        },
        onClick: g.bind(null, t)
      });
    }));
  },
      ee = function ee() {
    var e = Object(r.useContext)(l),
        n = e.index,
        t = e.images,
        i = e.goToSlide,
        a = e.previewStyle,
        c = e.previewActiveStyle,
        u = e.preview,
        s = void 0 === u || u,
        d = e.primaryColor,
        f = void 0 === d ? "#CCC" : d,
        p = function p(e) {
      e === n || i(e);
    },
        v = Object.assign({}, c, a);

    return o.a.createElement(U, {
      displayPreview: s
    }, t.map(function (e, r) {
      return o.a.createElement(F, {
        key: r,
        style: r === n ? v : a,
        active: r === n,
        length: t.length,
        image: e.image,
        color: f,
        onClick: p.bind(null, r)
      });
    }));
  };

  function ne(e) {
    for (var n = 1; n < arguments.length; n++) {
      if (n % 2) {
        var t = null != arguments[n] ? arguments[n] : {},
            r = Object.keys(t);
        "function" == typeof Object.getOwnPropertySymbols && (r = r.concat(Object.getOwnPropertySymbols(t).filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        }))), r.forEach(function (n) {
          te(e, n, t[n]);
        });
      } else Object.defineProperties(e, Object.getOwnPropertyDescriptors(arguments[n]));
    }

    return e;
  }

  function te(e, n, t) {
    return n in e ? Object.defineProperty(e, n, {
      value: t,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[n] = t, e;
  }

  function re(e, n) {
    return function (e) {
      if (Array.isArray(e)) return e;
    }(e) || function (e, n) {
      var t = [],
          r = !0,
          o = !1,
          i = void 0;

      try {
        for (var a, c = e[Symbol.iterator](); !(r = (a = c.next()).done) && (t.push(a.value), !n || t.length !== n); r = !0) {
          ;
        }
      } catch (e) {
        o = !0, i = e;
      } finally {
        try {
          r || null == c.return || c.return();
        } finally {
          if (o) throw i;
        }
      }

      return t;
    }(e, n) || function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }();
  }

  var oe = function oe(e) {
    var n = e.cover,
        t = void 0 === n || n,
        i = e.loop,
        a = void 0 === i || i,
        c = e.callback,
        l = e.containerStyle,
        s = e.autoPlay,
        d = e.duration,
        f = void 0 === d ? 2e3 : d,
        p = e.inputIndex,
        v = e.images,
        y = void 0 === v ? [] : v,
        g = e.swipe,
        m = void 0 !== g && g,
        b = e.preview,
        h = void 0 !== b && b,
        w = re(Object(r.useState)(0), 2),
        x = w[0],
        O = w[1];
    Object(r.useEffect)(function () {
      var e = s && setTimeout(S, f);
      return function () {
        return clearTimeout(e);
      };
    }, [x, s]), Object(r.useEffect)(function () {
      j(p);
    }, [p]);

    var S = function S() {
      var e = x;
      x < y.length - 1 ? e = x + 1 : !m && a && (e = 0), j(e);
    },
        j = function j(e) {
      e >= 0 && e < y.length && (O(e), c && c(e));
    };

    return y.length ? o.a.createElement(u, {
      value: ne({
        index: x
      }, e, {
        goToPreviousSlide: function goToPreviousSlide() {
          var e = x;
          x > 0 ? e = x - 1 : !m && a && (e = y.length - 1), j(e);
        },
        goToNextSlide: S,
        goToSlide: j
      })
    }, o.a.createElement(A, null, o.a.createElement(D, {
      cover: t,
      style: l
    }, o.a.createElement(J, null), o.a.createElement(Z, null)), h ? o.a.createElement(ee, null) : o.a.createElement($, null))) : null;
  };

  oe.propTypes = {
    cover: a.a.bool.isRequired,
    loop: a.a.bool.isRequired,
    duration: a.a.bool.isRequired,
    swipe: a.a.bool.isRequired,
    autoPlay: a.a.bool.isRequired,
    preview: a.a.bool.isRequired,
    callback: a.a.func.isRequired,
    inputIndex: a.a.number.isRequired,
    containerStyle: a.a.object,
    images: a.a.array
  };
  var ie = oe;
  t.d(n, "default", function () {
    return ie;
  });
}]);